// Extract and return the configuration from expivi
function saveConfiguration() {
  // do your screenshots before returning
  return expivi.saveConfiguration(512, 512);
}

// Create the variant as before
function createVariant(savedBundle) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'POST',
      url: '/apps/configurator',
      data: JSON.stringify({
        configuration: savedBundle.configured_products,
        productId: shopifyProductId
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
    }).done(function (createResult) {
      createResult.configuredProduct = savedBundle.configured_products[0];
      resolve(createResult);
    }).fail(reject);
  });
}

// Modified addToCart now accepts a quantity parameter
function addToCart(createResult, quantity) {
  return new Promise(function (resolve, reject) {
    console.log('Expivi add to cart: ', createResult.options);

    if (Object.keys(createResult.options).length < 3) {
      alert('Configuration is empty');
      return reject('Add to cart failed: Configuration is empty');
    }

    let addJsResponse = {
      quantity: quantity, // use the passed quantity instead of a fixed 1
      id: createResult.variant_id,
      properties: createResult.options,
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(addJsResponse),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
    }).done(resolve).fail(reject);
  });
}

// Main hook using async/await for clarity
window.xpv_hooks_add_to_cart = async function(context, event) {
  const $button = $(context);
  shopifyProductId = $button.data('productId');

  // Disable button
  if ($button[0].hasAttribute('disabled')) {
    return false;
  }
  event.preventDefault();
  $button.attr('disabled', 'disabled');
  $button.addClass('loading');

  try {
    // Save configuration and extract the quantity value from the attribute
    const configResult = await saveConfiguration();
    /*
    const quantity = configResult.configured_products[0].configuration.attributes
      .filter(attr => attr.attribute_id === 97847)
      .map(attr => attr.attribute_value_name)[0];
    */
    
      // Create variant and add to cart with the extracted attributeValue as quantity
    const createResult = await createVariant(configResult);
    await addToCart(createResult, 1);

    if ($button.data('url') !== 'NONE') {
      window.location.href = $button.data('url');
    }

    // Prevent further processing by expivi
    return false;
  } catch (error) {
    $button.removeAttr('disabled');
    $button.removeClass('loading');
    throw error;
  }
}
